import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { notAbpAuthGuard } from './core/guards/auth-guard.guard';
import { LoginComponent } from './modules/login/login/login.component';
import { MainComponent } from './modules/main/main.component';
import { OfflineDataResolver } from './offline-data.resolver';
import { 
  DASHBOARD_PERMISSION, 
  TOUR_REPORT_PERMISSION, 
  TOUR_REPORT_ACTION_PERMISSION, 
  TOUR_TYPE_PERMISSION, 
  FORM_PERMISSION, 
  ACTION_PERMISSION, 
  PROCESS_PERMISSION,
  ROLES_PERMISSION,
  USERS_PERMISSION,
  ROUTE_LOGIN_OFFLINE,
  ROUTE_HOME,
  ROUTE_TOUR_TYPE,
  ROUTE_FORM,
  ROUTE_ACTION,
  ROUTE_EXECUTED_ACTIONS,
  ROUTE_TOUR,
  ROUTE_SETTING_MANAGEMENT,
  ROUTE_IDENTITY
} from './core/constants/constants';
import { redirectPermissionGuard } from './core/guards/redirect-permission-guard.guard';

const routes: Routes = [
  {
    path: ROUTE_LOGIN_OFFLINE,
    pathMatch: 'prefix',
    component: LoginComponent,
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [notAbpAuthGuard],
    pathMatch: 'prefix',
    resolve: {OfflineDataResolver},
    children: [
      {
        path: ROUTE_HOME,
        loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: DASHBOARD_PERMISSION,
        }
      },
      {
        path: ROUTE_TOUR_TYPE,
        loadChildren: () => import('./modules/tourType/tour-type.module').then(m => m.TourTypeModule),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: TOUR_TYPE_PERMISSION
        }
      },
      {
        path: ROUTE_FORM,
        loadChildren: () => import('./modules/form/form.module').then(m => m.FormModule),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: FORM_PERMISSION
        }
      },
      {
        path: ROUTE_ACTION,
        loadChildren: () => import('./modules/actions/actions.module').then(m => m.ActionsModule),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: ACTION_PERMISSION
        }
      },
      {
        path: ROUTE_EXECUTED_ACTIONS,
        loadChildren: () => import('./modules/executed-actions/executed-actions.module').then(m => m.ExecutedActionsModule),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: TOUR_REPORT_ACTION_PERMISSION
        }
      },
      {
        path: ROUTE_TOUR,
        loadChildren: () => import('./modules/tours/tours.module').then(m => m.ToursModule),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: TOUR_REPORT_PERMISSION
        }
      },
      {
        path: ROUTE_SETTING_MANAGEMENT,
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: PROCESS_PERMISSION
        }
      },
      {
        path: ROUTE_IDENTITY,
        loadChildren: () => import('@volo/abp.ng.identity').then(m => m.IdentityModule.forLazy()),
        canActivate: [redirectPermissionGuard],
        data: {
          requiredPolicy: `${ROLES_PERMISSION} || ${USERS_PERMISSION}`
        }
      },
      {        
        path: '**',
        redirectTo: ROUTE_HOME,
      }
    ]
  },
  {
    path: '**',
    redirectTo: ROUTE_HOME,
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}